<template>
  <div class="step">
    <div class="step-wrapper">
      <template v-if="result">
        <h2>Данные отоневрологического<br> обследования</h2>
        <ul>
          <li><b>Стато-координаторные тесты:</b> отклонение влево</li>
          <li>
            <b>Глазодвигательные тесты:</b>
            <ul>
              <li>Скрытый правосторонний горизонтальный нистагм<br>2 степени в очках Френзеля</li>
              <li>Положительный тест встряхивания головы:<br>усиление правостороннего нистагма</li>
              <li>Положительный тест Хальмаги слева</li>
              <li>Саккады и плавное слежение без особенностей</li>
            </ul>
          </li>
          <li><b>Отрицательные позиционные диагностические тесты</b></li>
        </ul>
      </template>
      <template v-else>
        <h2>Какие тесты надо провести пациентке в рамках <br>отоневрологического обследования?</h2>
        <ul class="compact">
          <li
            v-for="(test, index) in tests"
            :key="test.title"
            @click="popup = test.popup"
          >
            <span v-html="test.title" :class="{ active: popup === test.popup }" />
            <hand v-if="index === 0 && !popup" class="hand" />
            <div class="exam-popup" :class="'exam-popup--' + popup" v-if="isMobile && popup && test.mobile_popup === popup">
              <template v-if="popup === 'stato' && test.mobile_popup === 'stato'">
                <h3>Стато-координаторные тесты</h3>
                <div class="exam-popup-content">
                  <div class="list">
                    <ul>
                      <li><b>Простой тест Ромберга:</b> <br>выполняет</li>
                      <li><b>Усложненненый тест<br>Ромберга:</b> отклонение влево</li>
                      <li><b>Тест Фукуда/Унтербергера:</b><br>поворот влево больше<br>чем на 30°</li>
                    </ul>
                  </div>
                  <div class="exam-video" @click="$emit('video', 'examination-1')">
                    <img class="thumb" src="@/assets/examination-video-1.jpg">
                    <div class="play">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 77 77">
                        <path fill="#FFF" fill-rule="evenodd" d="M38.493 76.999c-21.223 0-38.49-17.27-38.49-38.497C.003 17.272 17.27.001 38.493.001c21.231 0 38.504 17.271 38.504 38.501 0 21.227-17.273 38.497-38.504 38.497zm0-73.466c-19.276 0-34.958 15.687-34.958 34.969 0 19.28 15.682 34.965 34.958 34.965 19.284 0 34.972-15.685 34.972-34.965 0-19.282-15.688-34.969-34.972-34.969zM22.926 63.698V13.815l43.202 24.938-43.202 24.945z"/>
                      </svg>
                    </div>
                    <hand />
                  </div>
                </div>
              </template>
              <template v-if="popup === 'nistagma' && test.mobile_popup === 'nistagma'">
                <h3>Тест нистагма, тесты плавного<br>слежения, саккад и тест встряхивания<br>головы</h3>
                <div class="exam-popup-content">
                  <div class="list">
                    <ul>
                      <li><b>Явный SpN:</b> отсутствует</li>
                      <li><b>Cкрытый SpN:</b> правосторонний<br>горизонтальный нистагм при <br>взгляде прямо, вправо — 2 степень</li>
                      <li><b>Тест встряхивания головы:</b> <br>положительный, значительное <br>усиление правостороннего<br>горизонтального нистагма</li>
                      <li><b>Плавное слежение:</b> без особенностей</li>
                      <li><b>Саккады:</b> без особенностей</li>
                    </ul>
                  </div>
                  <div class="exam-video" @click="$emit('video', 'examination-2')">
                    <img class="thumb" src="@/assets/examination-video-2.jpg">
                    <div class="play">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 77 77">
                        <path fill="#FFF" fill-rule="evenodd" d="M38.493 76.999c-21.223 0-38.49-17.27-38.49-38.497C.003 17.272 17.27.001 38.493.001c21.231 0 38.504 17.271 38.504 38.501 0 21.227-17.273 38.497-38.504 38.497zm0-73.466c-19.276 0-34.958 15.687-34.958 34.969 0 19.28 15.682 34.965 34.958 34.965 19.284 0 34.972-15.685 34.972-34.965 0-19.282-15.688-34.969-34.972-34.969zM22.926 63.698V13.815l43.202 24.938-43.202 24.945z"/>
                      </svg>
                    </div>
                    <hand />
                  </div>
                </div>
              </template>
              <template v-if="popup === 'halmagi' && test.mobile_popup === 'halmagi'">
                <h3>Тест Хальмаги</h3>
                <div class="exam-popup-content">
                  <div class="exam-video" @click="$emit('video', 'examination-3')">
                    <img class="thumb" src="@/assets/examination-video-3.jpg">
                    <div class="play">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 77 77">
                        <path fill="#FFF" fill-rule="evenodd" d="M38.493 76.999c-21.223 0-38.49-17.27-38.49-38.497C.003 17.272 17.27.001 38.493.001c21.231 0 38.504 17.271 38.504 38.501 0 21.227-17.273 38.497-38.504 38.497zm0-73.466c-19.276 0-34.958 15.687-34.958 34.969 0 19.28 15.682 34.965 34.958 34.965 19.284 0 34.972-15.685 34.972-34.965 0-19.282-15.688-34.969-34.972-34.969zM22.926 63.698V13.815l43.202 24.938-43.202 24.945z"/>
                      </svg>
                    </div>
                    <hand />
                  </div>
                  <div class="exam-video" @click="$emit('video', 'examination-4')">
                    <img class="thumb" src="@/assets/examination-video-3.jpg">
                    <div class="play">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 77 77">
                        <path fill="#FFF" fill-rule="evenodd" d="M38.493 76.999c-21.223 0-38.49-17.27-38.49-38.497C.003 17.272 17.27.001 38.493.001c21.231 0 38.504 17.271 38.504 38.501 0 21.227-17.273 38.497-38.504 38.497zm0-73.466c-19.276 0-34.958 15.687-34.958 34.969 0 19.28 15.682 34.965 34.958 34.965 19.284 0 34.972-15.685 34.972-34.965 0-19.282-15.688-34.969-34.972-34.969zM22.926 63.698V13.815l43.202 24.938-43.202 24.945z"/>
                      </svg>
                    </div>
                  </div>
                </div>
                <div class="list">
                  <ul>
                    <li>Компенсаторная саккада при повороте головы влево</li>
                  </ul>
                </div>
              </template>
              <template v-if="popup === 'position' && test.mobile_popup === 'position'">
                <h3>Маневр укладывания на бок</h3>
                <div class="exam-popup-content">
                  <div class="list">
                    <ul>
                      <li>
                        <b>Отрицательный</b>
                        <br>Однако может быть некоторое
                        <br>усиление или появление
                        <br>имеющегося скрытого SpN
                        <br>как проявление лабиринтной
                        <br>асимметрии при движениях
                        <br>(адекватной нагрузки<br>
                        на вестибулярный анализатор)
                      </li>
                    </ul>
                  </div>
                  <div class="exam-video" @click="$emit('video', 'examination-5')">
                    <img class="thumb" src="@/assets/examination-video-5.jpg">
                    <div class="play">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 77 77">
                        <path fill="#FFF" fill-rule="evenodd" d="M38.493 76.999c-21.223 0-38.49-17.27-38.49-38.497C.003 17.272 17.27.001 38.493.001c21.231 0 38.504 17.271 38.504 38.501 0 21.227-17.273 38.497-38.504 38.497zm0-73.466c-19.276 0-34.958 15.687-34.958 34.969 0 19.28 15.682 34.965 34.958 34.965 19.284 0 34.972-15.685 34.972-34.965 0-19.282-15.688-34.969-34.972-34.969zM22.926 63.698V13.815l43.202 24.938-43.202 24.945z"/>
                      </svg>
                    </div>
                    <hand />
                  </div>
                </div>
              </template>
            </div>
          </li>
        </ul>
        <div class="exam-popup" :class="'exam-popup--' + popup" v-if="popup && !isMobile">
          <template v-if="popup === 'stato'">
            <h3>Стато-координаторные тесты</h3>
            <div class="exam-popup-content">
              <div class="list">
                <ul>
                  <li><b>Простой тест Ромберга:</b> <br>выполняет</li>
                  <li><b>Усложненненый тест<br>Ромберга:</b> отклонение влево</li>
                  <li><b>Тест Фукуда/Унтербергера:</b><br>поворот влево больше<br>чем на 30°</li>
                </ul>
              </div>
              <div class="exam-video" @click="$emit('video', 'examination-1')">
                <img class="thumb" src="@/assets/examination-video-1.jpg">
                <div class="play">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 77 77">
                    <path fill="#FFF" fill-rule="evenodd" d="M38.493 76.999c-21.223 0-38.49-17.27-38.49-38.497C.003 17.272 17.27.001 38.493.001c21.231 0 38.504 17.271 38.504 38.501 0 21.227-17.273 38.497-38.504 38.497zm0-73.466c-19.276 0-34.958 15.687-34.958 34.969 0 19.28 15.682 34.965 34.958 34.965 19.284 0 34.972-15.685 34.972-34.965 0-19.282-15.688-34.969-34.972-34.969zM22.926 63.698V13.815l43.202 24.938-43.202 24.945z"/>
                  </svg>
                </div>
                <hand />
              </div>
            </div>
          </template>
          <template v-if="popup === 'nistagma'">
            <h3>Тест нистагма, тесты плавного<br>слежения, саккад и тест встряхивания<br>головы</h3>
            <div class="exam-popup-content">
              <div class="list">
                <ul>
                  <li><b>Явный SpN:</b> отсутствует</li>
                  <li><b>Cкрытый SpN:</b> правосторонний<br>горизонтальный нистагм при <br>взгляде прямо, вправо — 2 степень</li>
                  <li><b>Тест встряхивания головы:</b> <br>положительный, значительное <br>усиление правостороннего<br>горизонтального нистагма</li>
                  <li><b>Плавное слежение:</b> без особенностей</li>
                  <li><b>Саккады:</b> без особенностей</li>
                </ul>
              </div>
              <div class="exam-video" @click="$emit('video', 'examination-2')">
                <img class="thumb" src="@/assets/examination-video-2.jpg">
                <div class="play">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 77 77">
                    <path fill="#FFF" fill-rule="evenodd" d="M38.493 76.999c-21.223 0-38.49-17.27-38.49-38.497C.003 17.272 17.27.001 38.493.001c21.231 0 38.504 17.271 38.504 38.501 0 21.227-17.273 38.497-38.504 38.497zm0-73.466c-19.276 0-34.958 15.687-34.958 34.969 0 19.28 15.682 34.965 34.958 34.965 19.284 0 34.972-15.685 34.972-34.965 0-19.282-15.688-34.969-34.972-34.969zM22.926 63.698V13.815l43.202 24.938-43.202 24.945z"/>
                  </svg>
                </div>
                <hand />
              </div>
            </div>
          </template>
          <template v-if="popup === 'halmagi'">
            <h3>Тест Хальмаги</h3>
            <div class="exam-popup-content">
              <div class="exam-video" @click="$emit('video', 'examination-3')">
                <img class="thumb" src="@/assets/examination-video-3.jpg">
                <div class="play">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 77 77">
                    <path fill="#FFF" fill-rule="evenodd" d="M38.493 76.999c-21.223 0-38.49-17.27-38.49-38.497C.003 17.272 17.27.001 38.493.001c21.231 0 38.504 17.271 38.504 38.501 0 21.227-17.273 38.497-38.504 38.497zm0-73.466c-19.276 0-34.958 15.687-34.958 34.969 0 19.28 15.682 34.965 34.958 34.965 19.284 0 34.972-15.685 34.972-34.965 0-19.282-15.688-34.969-34.972-34.969zM22.926 63.698V13.815l43.202 24.938-43.202 24.945z"/>
                  </svg>
                </div>
                <hand />
              </div>
              <div class="exam-video" @click="$emit('video', 'examination-4')">
                <img class="thumb" src="@/assets/examination-video-3.jpg">
                <div class="play">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 77 77">
                    <path fill="#FFF" fill-rule="evenodd" d="M38.493 76.999c-21.223 0-38.49-17.27-38.49-38.497C.003 17.272 17.27.001 38.493.001c21.231 0 38.504 17.271 38.504 38.501 0 21.227-17.273 38.497-38.504 38.497zm0-73.466c-19.276 0-34.958 15.687-34.958 34.969 0 19.28 15.682 34.965 34.958 34.965 19.284 0 34.972-15.685 34.972-34.965 0-19.282-15.688-34.969-34.972-34.969zM22.926 63.698V13.815l43.202 24.938-43.202 24.945z"/>
                  </svg>
                </div>
              </div>
            </div>
            <div class="list">
              <ul>
                <li>Компенсаторная саккада при повороте головы влево</li>
              </ul>
            </div>
          </template>
          <template v-if="popup === 'position'">
            <h3>Маневр укладывания на бок</h3>
            <div class="exam-popup-content">
              <div class="list">
                <ul>
                  <li>
                    <b>Отрицательный</b>
                    <br>Однако может быть некоторое
                    <br>усиление или появление
                    <br>имеющегося скрытого SpN
                    <br>как проявление лабиринтной
                    <br>асимметрии при движениях
                    <br>(адекватной нагрузки<br>
                    на вестибулярный анализатор)
                  </li>
                </ul>
              </div>
              <div class="exam-video" @click="$emit('video', 'examination-5')">
                <img class="thumb" src="@/assets/examination-video-5.jpg">
                <div class="play">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 77 77">
                    <path fill="#FFF" fill-rule="evenodd" d="M38.493 76.999c-21.223 0-38.49-17.27-38.49-38.497C.003 17.272 17.27.001 38.493.001c21.231 0 38.504 17.271 38.504 38.501 0 21.227-17.273 38.497-38.504 38.497zm0-73.466c-19.276 0-34.958 15.687-34.958 34.969 0 19.28 15.682 34.965 34.958 34.965 19.284 0 34.972-15.685 34.972-34.965 0-19.282-15.688-34.969-34.972-34.969zM22.926 63.698V13.815l43.202 24.938-43.202 24.945z"/>
                  </svg>
                </div>
                <hand />
              </div>
            </div>
          </template>
        </div>
      </template>
    </div>
    <div class="step-next" @click="!result ? result = true : $emit('step', 'diagnosis')">
      <span>Диагноз</span>
      <svg viewBox="0 0 27 12" width="27" height="12">
        <path fill="#FFF" fill-rule="evenodd" d="M.01 5h17.14C15.83 3.07 15.17 1.8 15.1.09c3.01 2.96 6.93 4.5 11.67 5.95C22.03 7.43 18.29 9.12 15.1 12c.2-1.86.75-2.99 2.1-5.04H0V5z"/>
      </svg>
    </div>
    <div class="cover" v-if="result">
      <span>Гипофункция<br>левого лабиринта</span>
    </div>
    <div class="step-help" v-else>
      <div class="video-opener" @click="showResult">
        <span>
          <img src="@/assets/test.png">
          Перейти<br>к итогам<br>обследования
        </span>
      </div>
      <hand />
    </div>

  </div>
</template>

<script>
import Hand from './hand'

export default {
  components: {
    Hand
  },
  data () {
    return {
      result: false,
      popup: null,
      tests: [
        {
          title: 'Стато-координаторные тесты',
          popup: 'stato',
          mobile_popup: 'stato'
        },
        {
          title: 'Тест оценки нистагма',
          popup: 'nistagma'
        },
        {
          title: 'Тест встряхивания головы',
          popup: 'nistagma'
        },
        {
          title: 'Саккады',
          popup: 'nistagma'
        },
        {
          title: 'Плавное слежение',
          popup: 'nistagma',
          mobile_popup: 'nistagma'
        },
        {
          title: 'Тест поворота головы <br>(Хальмаги)',
          popup: 'halmagi',
          mobile_popup: 'halmagi'
        },
        {
          title: 'Позиционные тесты <br>для диагностики ДППГ',
          popup: 'position',
          mobile_popup: 'position'
        }
      ]
    }
  },
  methods: {
    showResult () {
      this.result = true
      if (this.isMobile) {
        this.$scrollTo('#betaserc-m3-app', 200, { offset: -60 })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.step.step--examination {
  @include media-down(lg) {
    padding: 15px 0;
  }
  @include media-down(md) {
    padding: 0;
    display: flex;
    flex-direction: column;
  }
}
ul {
  font-size: 18px;
  line-height: 1.15;
  color: #252628;
  margin: 0;
  padding: 0;
  font-weight: normal;

  @include media-down(lg) {
    font-size: 16px;
  }

  &.compact {
    margin: 35px 0;

    @include media-down(lg) {
      margin: 15px 0;
    }

    li {
      margin: 15px 0;
      position: relative;

      .hand {
        top: 100%;
      }

      span {
        color: #005da3;
        font-weight: 500;
        text-decoration: underline;
        cursor: pointer;

        &.active {
          color: #282828;
          text-decoration: none;
        }
      }
    }
  }

  ul {
    margin-left: 20px;

    @include media-down(lg) {
      margin-left: 0;
    }

    li {
      margin: 10px 0;

      &:before {
        border-left-color: #bfbfbf;
      }
    }
  }

  li {
    padding: 0 0 0 20px;
    margin: 20px 0;
    list-style: none;
    position: relative;

    &:before {
      content: '';
      position: absolute;
      width: 0;
      height: 0;
      left: 0;
      top: .35em;
      border-left: 10px solid #e97827;
      border-bottom: 5px solid transparent;
      border-top: 5px solid transparent;
    }
  }
}
.cover {
  position: absolute;
  border-radius: 50%;
  top: 0;
  right: 0;
  height: 100%;
  width: 438px;
  background: url(../assets/step-examination.jpg);
  background-size: 100% 100%;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  color: #e97827;
  font-size: 24px;
  line-height: 1;
  font-weight: bold;
  padding: 150px 0 0;

  @include media-down(lg) {
    width: 360px;
    height: 360px;
    padding: 120px 0 0;
    font-size: 22px;
  }
  @include media-down(md) {
    position: static;
    width: 200px;
    height: 200px;
    margin: 0 auto;
    padding: 80px 0 0;
    font-size: 16px;
    order: -1;
  }
}
.step-help {
  right: 30px;

  @include media-down(md) {
    right: auto;
  }
}
.exam-popup {
  position: absolute;
  background: #fff;
  border: 1px solid #009cde;
  border-radius: 3px;
  left: 330px;
  top: 45%;
  width: 510px;
  margin: 60px 0 0;
  transform: translate(0, -50%);
  padding: 20px 15px;
  box-shadow: 0 6px 12px 2px rgba(170, 204, 219, .34);

  &:before {
    content: '';
    position: absolute;
    right: 100%;
    top: 20px;
    border-right: 20px solid #009cde;
    border-top: 5px solid transparent;
    border-bottom: 10px solid transparent;
    transform-origin: 100% 50%;
    transform: skewY(20deg);
  }
  &:after {
    content: '';
    position: absolute;
    right: 100%;
    top: 21px;
    margin-right: -2px;
    border-right: 19px solid #fff;
    border-top: 5px solid transparent;
    border-bottom: 10px solid transparent;
    transform-origin: 100% 50%;
    transform: skewY(20deg);
  }

  @include media-down(lg) {
    width: 380px;
    left: 290px;
    top: 100px;
  }

  @include media-down(md) {
    position: static;
    width: auto;
    transform: none;
    margin: 20px 0 20px -20px !important;

    &:after,
    &:before {
      display: none;
    }
  }

  h3 {
    color: #009cde;
    font-size: 24px;
    line-height: .9;
    padding: 0;
    margin: 0 0 20px;
    font-weight: bold;

    @include media-down(lg) {
      font-size: 18px;
      margin: 0 0 10px;

      br {
        display: none;
      }
    }
  }
  ul {
    font-size: 16px;
    line-height: .9;
    color: #282828;
    margin: 0;

    @include media-down(lg) {
      font-size: 14px;
    }

    li {
      padding: 0 0 0 10px;
      margin: 0 0 13px;

      &:last-child {
        margin-bottom: 5px;
      }

      @include media-down(lg) {
        margin: 0 0 10px;
      }

      &:before {
        border: none;
        width: 5px;
        height: 5px;
        top: .25em;
        background: #009cde;
        border-radius: 50%;
      }
    }
  }
  &-content {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    @include media-down(md) {
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
    }
  }
  .exam-video {
    border: 5px solid #bdd3e0;
    position: relative;
    margin-left: 10px;

    @include media-down(lg) {
      border-width: 3px;
    }
    @include media-down(md) {
      margin: 20px 0 0 !important;
      align-self: center;
    }

    .thumb {
      display: block;
      margin: 0;

      @include media-down(lg) {
        height: 100px !important;
        width: auto;
      }
    }

    .hand {
      left: 50%;
      top: 50%;
      z-index: 2;
    }

    .play {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);

      svg {
        width: 77px;
        height: 77px;
      }
    }
  }

  &--nistagma {
    top: 190px;

    &:before {
      top: 100px;
    }
    &:after {
      top: 101px;
    }

    @include media-down(lg) {
      padding: 10px 15px;
      top: 140px;
    }
    ul {
      margin-right: -20px;
    }
    .exam-video {
      margin-top: -20px;

      @include media-down(lg) {
        margin-top: 0;
      }
    }
  }
  &--halmagi {
    @include media-down(lg) {
      top: 160px;
    }

    &:before {
      top: 200px;

      @include media-down(lg) {
        top: 140px;
      }
    }
    &:after {
      top: 201px;

      @include media-down(lg) {
        top: 141px;
      }
    }

    .exam-popup-content {
      margin-bottom: 20px;
    }
  }
  &--position {
    top: 200px;

    &:before {
      top: 240px;

      @include media-down(lg) {
        top: 150px;
      }
    }
    &:after {
      top: 241px;

      @include media-down(lg) {
        top: 151px;
      }
    }

    @include media-down(lg) {
      top: 180px;
    }

   .exam-popup-content {
      align-items: center;

       @include media-down(md) {
        align-items: flex-start;
      }
    }
  }
}
</style>
